<template>
	<div>
		<h2 class="clearfix mb-2">
			{{$t('edit')}}
			<div class="float-right">
                <button @click="openDialog('delete')" class="btn btn-danger" :disabled="!station.id">{{ $t('delete') }}</button>
				<button @click="saveStation" class="btn btn-primary ml-2" :disabled="!station.title">{{ $t('save') }}</button>
			</div>
		</h2>
		<div class="row mb-2">
			<div class="col-12">
                <div class="row">
                    <TextInput
                        :label="$t('code')"
                        v-model="station.code"
                        class="col-md-3"
                    />

                    <TextInput
                        :label="$t('title')"
                        v-model="station.title"
                        class="col-md-6"
                    />

                    <NumberInput
                        :label="$t('duration-minutes')"
                        v-model="station.duration"
                        class="col-md-3"
                    />
                </div>

				<TextAreaAutosize
					:label="$t('description')"
					v-model="station.note"
					class="mb-4"
				/>

				<div class="form-group">
					<label>{{ $t('form') }}</label>
					<input
						type="text"
						:value="selectedFormTitle"
						class="form-control"
						@focus="selectForm"
					/>
				</div>
				
			</div>
		</div>
	
    </div>
</template>

<script>
import NumberInput from "../../../components/Inputs/NumberInput.vue";

export default {
	components: {
        NumberInput,
	},
	mounted() {
		this.getForms(),
        this.fetchStation()
	},
    data() {
        return {
			loading: true,
			submitting: false,
        	tabIndex: 0,
        	station: {
        		id: null,
				osce_id: this.$route.params.osceid,
				form_id: null,
        		title: '',
        		note: '',
                code: '',
                duration: null
        	},
        	saved: false,
            error: {},
        	forms: []
        }
    },
    methods: {
    	saveStation() {
			if (this.submitting) return
			this.submitting = true

			this.$store.commit('showBlockingSpinner'
			)
			this.$cfetch(`${this.$settings.APIBaseURL}/osce/stations/save`, {
  				method: 'post',
  				data: this.station,
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving workflow station')

				this.$router.go(-1);
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-saving-station'),
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
				this.submitting = false
			})
    	},
        deleteStation(){
            //if (this.submitting || !this.station.id) return
			this.submitting = true

			this.$store.commit('showBlockingSpinner'
			)
			this.$cfetch(`${this.$settings.APIBaseURL}/osce/stations/delete`, {
  				method: 'post',
  				data: this.station,
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving workflow station')

				this.$router.push(`/settings/osce/edit/${this.$route.params.osceid}`)
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-deleting-station'),
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
				this.submitting = false
			})
        },
    	fetchStation() {
			if (!this.$route.params.id) return Promise.resolve()

			this.$store.commit('showBlockingSpinner')

  			return this.$cfetch(`${this.$settings.APIBaseURL}/osce/stations/get`, {
  				data: {
  					id: this.$route.params.id
  				}
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching station')

				this.station = res.result
				this.loading = false
                
			})
			.catch(error => {
				console.error(error)
				this.$log.error.call(this, error)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-fetching-station'),
					confirmCallBack: function () {
						this.$router.push('/settings/osce')
					}
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
			})
    	},
        getUsersByPriv(priv) {
            return this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
                {
                    method: "post",
                    data: {
                        priv: priv
                    }
                }
            )
            .then(res => {
                if (res.status == "SUCCESS") {
                	return res.users.map(user => {
                        return {
                            ...user,
                            displayname: user.displayName
                        }
                    });
                }
            })
            .catch(error => {
                this.$log.error.call(this, error);
            });
		},
		selectForm() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Form',
				selectCallback: function (selection) {
					self.station.form_id = selection.id;
					self.$store.commit("closeModal");
				},
				selected: [{ id: this.station.form_id }],
				data: this.forms,
				captionKey: 'title'
			});
		},
		getForms() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/forms/listall`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.forms = json.results;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
        openDialog(action) {
            if (action !== 'delete') return;
            var self = this;
            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t(`${action}-{e}-warning`, { e: this.$t('station') }),
                cancelBtn: true,
                confirmCallBack: function () {
                    self.deleteStation(action)
                }
            })
        }
    },
	computed: {
		selectedFormTitle() {
			if(this.station.form_id){
				for(const form of this.forms) {
					if(form.id == this.station.form_id) {
						return form.title;
					}
				}
			}
			return null;
		}
	}

}
</script>
